export default "__VITE_ASSET__2edfcb7e__"